import { palettes } from '@backstage/theme';
import {
  essityBrand,
  essityOverlayOnDark,
  essityStatus,
  essityStatusInfo,
  essityStatusSurface,
  essityUiTones,
} from './colours';

export const createEssityDarkPalette = (surface: {
  default: string;
  paper: string;
}) => ({
  ...palettes.dark,
  primary: { main: essityUiTones.pinkOnDark },
  secondary: { main: essityBrand.neutral },
  error: { main: essityStatus.error },
  warning: { main: essityStatus.warning },
  info: { main: essityStatusInfo.dark },
  success: { main: essityStatus.success },
  background: { default: surface.default, paper: surface.paper },
  link: essityUiTones.pinkOnDark,
  linkHover: essityBrand.white,
  banner: {
    info: essityBrand.navy,
    error: essityStatus.error,
    text: essityBrand.white,
    link: essityUiTones.pinkOnDark,
  },
  errorBackground: essityStatusSurface.dark.error,
  warningBackground: essityStatusSurface.dark.warning,
  infoBackground: essityStatusSurface.dark.info,
  navigation: {
    background: essityBrand.navy,
    indicator: essityBrand.pink,
    color: essityBrand.white,
    selectedColor: essityUiTones.pinkOnDark,
    navItem: { hoverBackground: essityOverlayOnDark },
    submenu: { background: surface.paper },
  },
});
